import optionsApi from "./optionsApi";

export async function getManagerDashboard(): Promise<any> {
  return optionsApi
    .get("/v1/manager-portal/dashboard")
    .then((res) => res?.data?.data);
}

export async function getManagerTeam(): Promise<any[]> {
  return optionsApi
    .get("/v1/manager-portal/team")
    .then((res) => res?.data?.data || []);
}

export async function getTeamMemberDetail(employeeId: string): Promise<any> {
  return optionsApi
    .get(`/v1/manager-portal/team/${employeeId}`)
    .then((res) => res?.data?.data);
}

export async function getManagerReports(): Promise<any[]> {
  return optionsApi
    .get("/v1/manager-portal/reports")
    .then((res) => res?.data?.data || []);
}

export async function getManagerViewEmployeeToken(
  employeeId: string
): Promise<any> {
  return optionsApi
    .get(`/v1/manager-portal/team/employee-token/${employeeId}`)
    .then((res) => res.data);
}

export async function getTeamMemberGrants(employeeId: string): Promise<any[]> {
  return optionsApi
    .get(`/v1/manager-portal/team/grants/${employeeId}`)
    .then((res) => res?.data?.data || []);
}

export async function getTeamMemberGrantDetails(grantId: string): Promise<any> {
  return optionsApi
    .get(`/v1/manager-portal/team/grant/${grantId}`)
    .then((res) => res?.data?.data);
}

export async function getTeamMemberVestingDetails(
  employeeId: string
): Promise<any[]> {
  return optionsApi
    .get(`/v1/manager-portal/team/vesting-schedule/${employeeId}`)
    .then((res) => res?.data?.data || []);
}
